export default __webpack_public_path__ + "static/media/bookmark.2ec7da4e.svg";